function getOffsetTop(elem) {
    if (elem.nodeName === 'svg') {
        return elem.getBoundingClientRect().top;
    }
    let offsetTop = 0;
    do {
        if (!isNaN(elem.offsetTop)) {
            offsetTop += elem.offsetTop;
        }
    } while (elem = elem.offsetParent);
    return offsetTop;
}
function getOffsetLeft(elem) {
    if (elem.nodeName === 'svg') {
        return elem.getBoundingClientRect().left;
    }
    let offsetLeft = 0;
    do {
        if (!isNaN(elem.offsetLeft)) {
            offsetLeft += elem.offsetLeft;
        }
    } while (elem = elem.offsetParent);
    return offsetLeft;
}

export function inView(options) {

    const opts = {};
    const self = this;
    const visibleElements = new (window.WeakSet || window.Set)();

    const defaultOpts = {
        onVisible(elem) {
            elem.classList.add('visible');
        },
        onHidden(elem) {
            elem.classList.remove('visible');
        },
        tolerance: 0,
        repeat: false,
        debug: false,
    };

    options = options || {};

    if (typeof options.onHidden === 'function') {
        options.repeat = true;
    }

    if (options.debug === true) {
        var debugArea = document.createElement('div');
        document.querySelector('body').appendChild(debugArea);
        debugArea.style.backgroundColor = 'rgba(0, 210, 0, 0.3)';
        debugArea.style.position = 'absolute';
        debugArea.style.width = '100%';
        debugArea.style.zIndex = '1000';
        debugArea.style.pointerEvents = 'none';
    }

    Object.assign(opts, defaultOpts, options);
    if (opts.elems) {
        if (opts.elems instanceof HTMLElement) {
            opts.elems = [opts.elems];
        } else {
            opts.elems = Array.prototype.slice.call(opts.elems);
        }
    }

    const checkVisible = function () {
        const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        const scrollNode = document.scrollingElement || document.documentElement;

        opts.elems.forEach((elem) => {
            const top = getOffsetTop(elem); // pozycja górnej krawędzi elementu
            const bottom = top + elem.offsetHeight; // pozycja dolnej krawędzi elementu
            const left = getOffsetLeft(elem) - scrollNode.scrollLeft; // pozycja lewej krawędzi elementu
            const right = left + elem.offsetWidth; // pozycja prawej krawędzi elementu

            const toleranceSize = viewportHeight * opts.tolerance; // szerokość pasów tolerancji - w nich elementy nie są obserwowane

            let toleranceTop = scrollNode.scrollTop + toleranceSize; // odległość od góry dokumentu do krawędzi górnego pasa tolerancji
            let toleranceBottom = scrollNode.scrollTop + viewportHeight - toleranceSize; // odległość od góry dokumentu do krawędzi dolnego pasa tolerancji

            let observedArea = toleranceBottom - toleranceTop; // fragment viewportu w którym obecność elementów jest obserwowana

            let isVisible; // boolean - czy element jest obecny w obszarze obserwowanym
            let isVisibleWithoutTolerance; // boolean - czy element jest obecny w viewporcie

            if (document.documentElement.scrollHeight - (scrollNode.scrollTop + viewportHeight) < toleranceSize) {
                toleranceBottom = scrollNode.scrollTop + viewportHeight;
                observedArea = toleranceBottom - toleranceTop;
            }
            if (scrollNode.scrollTop < toleranceSize) {
                toleranceTop = 0;
                observedArea = toleranceBottom - toleranceTop;
            }
            if (options.debug === true) {
                debugArea.style.top = `${toleranceTop}px`;
                debugArea.style.height = `${observedArea}px`;
            }

            // czy element widoczny w obszarze obserwowanym
            if (elem.offsetHeight > observedArea) { // element wyższy od obszaru obserwowanego
                isVisible = (bottom < toleranceBottom && bottom > toleranceTop || top < toleranceBottom && top > toleranceTop) || (top < toleranceTop && bottom > toleranceBottom);
            } else { // element niższy od obszaru obserwowanego
                isVisible = (bottom < toleranceBottom && bottom > toleranceTop || top < toleranceBottom && top > toleranceTop);
            }
            // czy element widoczny w viewporcie
            if (elem.offsetHeight > viewportHeight) { // element wyższy od viewportu
                isVisibleWithoutTolerance = (bottom < scrollNode.scrollTop + viewportHeight && bottom > scrollNode.scrollTop || top < scrollNode.scrollTop + viewportHeight && top > scrollNode.scrollTop) || (top < scrollNode.scrollTop && bottom > scrollNode.scrollTop + viewportHeight);
            } else { // element niższy od viewportu
                isVisibleWithoutTolerance = (bottom < scrollNode.scrollTop + viewportHeight && bottom > scrollNode.scrollTop || top < scrollNode.scrollTop + viewportHeight && top > scrollNode.scrollTop);
            }

            if (isVisible) {
                if (!visibleElements.has(elem)) {
                    visibleElements.add(elem);
                    opts.onVisible(elem);
                }
            }

            if (!isVisibleWithoutTolerance && opts.repeat === true) {
                if (visibleElements.has(elem)) {
                    visibleElements.delete(elem);
                    opts.onHidden(elem);
                }
            }
        });
    };
    if (document.readyState === 'complete') {
        checkVisible();
    } else {
        addEventListener('load', checkVisible, false);
    }

    addEventListener('inview', checkVisible, false);
    addEventListener('scroll', checkVisible, false);
    addEventListener('resize', checkVisible, false);
}
